import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { ACCESS_TOKEN, ID_TOKEN, LocalStorage } from '../../../util/LocalStorage';
import { ProjectFilePostDto } from '../../../commonTypes/project.types';

const MAX_FILE_SIZE_BYTES = 10000000;

const useHttpPostProjectFile = () => {
    const projectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const storage = useContainer(LocalStorage);
    const { t } = useTranslation('newNotifications');

    const exec = ({ projectId, file, fileType, name, onSuccess }: ProjectFilePostDto) => {
        projectApi
            .createProjectFile({
                projectId,
                fileType,
                file,
                name,
                accessToken: storage.get(ACCESS_TOKEN),
                idToken: storage.get(ID_TOKEN),
            })
            .then(() => {
                toastHandler.push(`success`, t('projectFile.uploadTitle'), t('projectFile.uploadSuccess'));
                onSuccess?.();
            })
            .catch(err => {
                if (file.size > MAX_FILE_SIZE_BYTES) {
                    toastHandler.push('error', t('projectFile.uploadTitle'), t('projectFile.maxLimitErrorMessage'));
                    return;
                }
                toastHandler.push('error', t('projectFile.uploadTitle'), err.fault?.message ?? t('projectFile.uploadError'));
            });
    };

    return { exec };
};

export default useHttpPostProjectFile;
